import React, { useEffect, useState } from "react";
import { Lightbulb } from "lucide-react";
import { SpotForm } from "@/components/SpotForm";
import type { Suggestion } from "@/components/AdminSpotSuggestions";
import { api } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";

const tone = { pending: "bg-amber-100 text-amber-700", approved: "bg-emerald-100 text-emerald-700", rejected: "bg-rose-100 text-rose-700" };

export const SuggestSpot = () => {
  const { t } = usePrefs();
  const [open, setOpen] = useState(false);
  const [mine, setMine] = useState<Suggestion[]>([]);
  const load = () => api.get("/me/spot-suggestions").then((r) => setMine(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-3">
      <button data-testid="suggest-spot-button" onClick={() => setOpen(true)} className="w-full sm:w-auto h-12 px-5 rounded-2xl border-2 border-dashed border-emerald-500/50 text-emerald-700 dark:text-emerald-400 font-bold inline-flex items-center justify-center gap-2 hover:bg-emerald-500/5">
        <Lightbulb className="h-5 w-5" />{t("sug.cta")}
      </button>
      {!!mine.length && (
        <details data-testid="my-suggestions" className="rounded-2xl border bg-card p-3">
          <summary className="cursor-pointer text-sm font-bold">{t("sug.mine").replace("{n}", String(mine.length))}</summary>
          <div className="mt-3 space-y-2">
            {mine.map((x) => (
              <div key={x.suggestion_id} data-testid={`my-suggestion-${x.suggestion_id}`} className="flex items-center justify-between gap-2 text-sm">
                <span className="truncate">{x.name_ar}{x.reject_reason ? <span className="text-xs text-rose-600"> — {x.reject_reason}</span> : null}</span>
                <span data-testid={`my-suggestion-status-${x.suggestion_id}`} className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-bold ${tone[x.status]}`}>{t(`sug.status.${x.status}`)}</span>
              </div>
            ))}
          </div>
        </details>
      )}
      {open && <SpotForm spot={null} suggest onClose={() => setOpen(false)} onSaved={() => { setOpen(false); load(); }} />}
    </div>
  );
};
